document.documentElement.classList.add('js');
document.addEventListener('click',event=>{const trigger=event.target.closest('[data-drawer-trigger]');const drawer=document.querySelector('[data-drawer]');if(trigger&&drawer){const open=!drawer.hasAttribute('open');drawer.toggleAttribute('open',open);trigger.setAttribute('aria-expanded',String(open));}if(event.target.closest('[data-drawer-close]')&&drawer){drawer.removeAttribute('open');}});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('[open]:not(dialog)').forEach(element=>element.removeAttribute('open'));}});
document.addEventListener('change',event=>{if(event.target.matches('[data-sort]')){const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);location.href=url.toString();}});
document.addEventListener('click',event=>{const button=event.target.closest('[data-nav-toggle]');if(!button)return;const item=button.closest('.studio-nav__item');const expanded=button.getAttribute('aria-expanded')==='true';document.querySelectorAll('[data-nav-toggle]').forEach(other=>{other.setAttribute('aria-expanded','false');other.closest('.studio-nav__item')?.classList.remove('is-open')});button.setAttribute('aria-expanded',String(!expanded));item?.classList.toggle('is-open',!expanded)});
document.addEventListener('click',event=>{if(event.target.closest('.studio-nav__item'))return;document.querySelectorAll('[data-nav-toggle]').forEach(button=>{button.setAttribute('aria-expanded','false');button.closest('.studio-nav__item')?.classList.remove('is-open')})});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('[data-nav-toggle]').forEach(button=>{button.setAttribute('aria-expanded','false');button.closest('.studio-nav__item')?.classList.remove('is-open')})});

document.addEventListener('pointerover',event=>{const item=event.target.closest('.studio-nav__item');if(!item||!matchMedia('(hover: hover)').matches)return;document.querySelectorAll('.studio-nav__item.is-open').forEach(other=>{if(other===item)return;other.classList.remove('is-open');other.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false')})});

// Keep hover menus and accessibility state in sync on devices with a real pointer.
document.addEventListener('pointerover',event=>{if(!matchMedia('(hover: hover) and (pointer: fine)').matches)return;const item=event.target.closest('.studio-nav__item');if(!item)return;clearTimeout(item._closeTimer);document.querySelectorAll('.studio-nav__item').forEach(other=>{const active=other===item;other.classList.toggle('is-open',active);other.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded',String(active))})});
document.addEventListener('pointerout',event=>{if(!matchMedia('(hover: hover) and (pointer: fine)').matches)return;const item=event.target.closest('.studio-nav__item');if(!item||item.contains(event.relatedTarget))return;clearTimeout(item._closeTimer);item._closeTimer=setTimeout(()=>{if(item.matches(':hover')||item.contains(document.activeElement))return;item.classList.remove('is-open');item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false')},180)});

document.addEventListener('click',event=>{const openButton=event.target.closest('[data-mobile-search]');const closeButton=event.target.closest('[data-mobile-search-close]');const panel=document.querySelector('[data-mobile-search-panel]');if(openButton&&panel){if(typeof panel.showModal==='function')panel.showModal();else panel.setAttribute('open','');requestAnimationFrame(()=>panel.querySelector('input[name="q"]')?.focus())}if(closeButton&&panel){if(typeof panel.close==='function')panel.close();else panel.removeAttribute('open')}});
document.addEventListener('click',event=>{const panel=event.target.closest('[data-mobile-search-panel]');if(panel&&event.target===panel){if(typeof panel.close==='function')panel.close();else panel.removeAttribute('open')}});

(() => {
  const panel = document.querySelector('[data-mobile-search-panel]');
  if (!panel || !window.visualViewport) return;
  const update = () => {
    if (panel.open) panel.style.setProperty('--studio-search-height', Math.round(window.visualViewport.height) + 'px');
  };
  window.visualViewport.addEventListener('resize', update);
  panel.addEventListener('focusin', update);
  panel.addEventListener('close', () => panel.style.removeProperty('--studio-search-height'));
  document.addEventListener('click', event => {if (event.target.closest('[data-mobile-search]')) requestAnimationFrame(update);});
})();

const initializeCategoryVideos = (root = document) => {
  const videos = root.querySelectorAll('[data-hover-video]:not([data-video-initialized])');
  if (!videos.length) return;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loadVideo = video => {
    if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
    video.muted = true;
    video.playsInline = true;
  };
  const showCoverFrame = video => {
    loadVideo(video);
    const seek = () => {
      const requestedTime = Number(video.dataset.coverTime) || 0;
      const coverTime = Math.min(requestedTime, Math.max(0, video.duration - 0.1));
      const reveal = () => {
        video.removeAttribute('poster');
        video.removeEventListener('seeked', reveal);
      };
      video.addEventListener('seeked', reveal, { once: true });
      video.currentTime = coverTime;
      if (Math.abs(video.currentTime - coverTime) < 0.01) reveal();
    };
    if (video.readyState >= 1) seek();
    else video.addEventListener('loadedmetadata', seek, { once: true });
  };
  const coverObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        showCoverFrame(video);
        coverObserver.unobserve(video);
      }
    });
  }, { rootMargin: '300px 0px', threshold: 0.01 });
  videos.forEach(video => {
    video.setAttribute('data-video-initialized', '');
    coverObserver.observe(video);
  });

  if (finePointer) {
    videos.forEach(video => {
      const card = video.closest('.category-card');
      if (!card) return;
      card.addEventListener('pointerenter', () => {
        if (reduceMotion) return;
        loadVideo(video);
        video.play().catch(() => {});
      });
      card.addEventListener('pointerleave', () => {
        video.pause();
        showCoverFrame(video);
      });
    });
    return;
  }

  if (reduceMotion) return;
  const playObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        loadVideo(video);
        video.play().catch(() => {});
      } else {
        video.pause();
        showCoverFrame(video);
      }
    });
  }, { threshold: 0.55 });
  videos.forEach(video => playObserver.observe(video));
};

initializeCategoryVideos();
document.addEventListener('shopify:section:load', event => initializeCategoryVideos(event.target));

document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const drawer=document.querySelector('[data-drawer]');const trigger=document.querySelector('[data-drawer-trigger]');if(trigger?.getAttribute('aria-expanded')==='true'){drawer?.removeAttribute('open');trigger.setAttribute('aria-expanded','false');trigger.focus()}});
document.addEventListener('click',event=>{if(!event.target.closest('[data-drawer-close]'))return;const trigger=document.querySelector('[data-drawer-trigger]');trigger?.setAttribute('aria-expanded','false');trigger?.focus()});
